import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import NavBarDrawer from "../../NavBar/navDrawer";

import { PRIMARY_COLOR } from "utils/const";
import logoWhite from "images/Digital-Transformation.png";
import { Img, StyledP } from "./NavBarStyles";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";

import { useDispatch } from "react-redux";
import { setCurrentUser } from "redux/actions/index";

import useGet from "hooks/useFetch";
import { showMarkerseByTypeObject } from "redux/actions/admin";
import {
  setShowDataComponentsLibrary,
  showEventsByInspectionType,
  showEventsByType,
  showOperationsByType,
} from "redux/actions/digitalTwin";

const settings = ["Profile", "Dashboard", "Help", "Log Out"];

const ResponsiveAppBar = ({ linkLogo }) => {
  const userId = localStorage.getItem("userId");
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [user, userError] = useGet(`api/v1/users/${userId}`);
  const dispatch = useDispatch();
  const status = localStorage.getItem("role");
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const navigate = useNavigate();
  const openLink = (url) => window.open(url, "_blank")?.focus();

  const lastLogin = async () => {
    const date = new Date();
    const lastLogin = format(date, "yyyy-MM-dd'T'HH:mm:ss");

    try {
      await axios.patch(
        `${process.env.REACT_APP_URL_BACKEND}api/v1/user-verification/last-login/${userId}`,
        { lastLogin: lastLogin }
      );
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {

  // }, [open]);
  const handleCloseUserMenu = (event) => {
    setAnchorElUser(null);
    const option = event.currentTarget.innerText;
    switch (option) {
      case "Profile":
        status === "Administrador de compañía"
          ? navigate("/profileAdmin")
          : status === "Operario"
          ? navigate("/profile")
          : navigate("/profile-admin-decimetrix");
        break;
      case "Dashboard":
        status === "Administrador de compañía"
          ? navigate("/dashboard-admin-decimetrix")
          : navigate("/dashboard-admin-decimetrix");
        break;
      case "Help":
        openLink("https://co.linkedin.com/company/decimetrix");
        break;
      case "Log Out":
        localStorage.setItem("loginStatus", false);
        // localStorage.removeItem("adminCompanyId");
        // localStorage.removeItem("role");
        // localStorage.removeItem("userId");
        // localStorage.removeItem("loginStatus");
        // localStorage.removeItem("token");
        // localStorage.removeItem("adminDecimetrixId");
        // localStorage.removeItem("operatorId");
        localStorage.clear();
        lastLogin();
        dispatch(setCurrentUser({}));
        dispatch(showMarkerseByTypeObject([]));
        dispatch(showEventsByInspectionType({}));
        dispatch(showOperationsByType({}));
        dispatch(showEventsByType([]));
        dispatch(setShowDataComponentsLibrary([]));
        navigate("/SignIn");
        break;
      default:
        break;
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: PRIMARY_COLOR,
        height: "80px",
        justifyContent: "center",
      }}
    >
      <Toolbar
        style={{
          paddingRight: 40,
        }}
      >
        <NavBarDrawer />
        <Box component="div" sx={{ flexGrow: 5, mr: 2 }}>
          <Link to={`/${linkLogo}`}>
            <Img src={logoWhite} />
          </Link>
        </Box>
        <Box
          component="p"
          sx={{
            display: "flex",
            mr: 3,
          }}
        >
          {!userError && user && (
            <StyledP>
              {user.operator !== null ? (
                <>
                  {user.operator.firstName} {user.operator.firstLastName}
                </>
              ) : user.adminCompany !== null ? (
                <>
                  {user.adminCompany.firstName}{" "}
                  {user.adminCompany.firstLastName}
                </>
              ) : user.adminDecimetrix !== null ? (
                <>
                  {user.adminDecimetrix.firstName}{" "}
                  {user.adminDecimetrix.firstLastName}
                </>
              ) : null}
            </StyledP>
          )}
        </Box>

        <Box sx={{ flexGrow: 0 }}>
          {user && (
            <Tooltip title="Open Settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="photo-profile" src={user.urlPhoto} size="small" />
              </IconButton>
            </Tooltip>
          )}
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={handleCloseUserMenu}>
                <Typography
                  sx={{
                    fontSize: "1.4rem",
                  }}
                  textAlign="center"
                >
                  {setting}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default ResponsiveAppBar;
